/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_No_ActiveInputs */



/**
* | output |
* | --- |
* | "No active leagues. Try enabling \"Show past leagues\"." |
*
* @param {League_No_ActiveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_no_active = /** @type {((inputs?: League_No_ActiveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_No_ActiveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune ligue active. Essayez d'activer « Afficher les ligues passées ».")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay ligas activas. Intente activar \"Mostrar ligas pasadas\".")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhuma liga ativa. Tente ativar \"Mostrar ligas encerradas\".")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun campionato attivo. Provi ad attivare \"Mostra campionati passati\".")
	return /** @type {LocalizedString} */ ("No active leagues. Try enabling \"Show past leagues\".")
});